import styled from 'styled-components';
import { Close } from 'styled-icons/evil/Close';


export const Container = styled.div`
    display: flex; 
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 95%;
    padding: 10px 30px;
`;

export const TopLabel = styled.span`
    font-family: "SourceSansPro", Arial, sans-serif !important;
    font-size: 14px;
    font-weight: 500;
    text-align: left;
    color: ${props => props.theme.alert};
    margin-top: 50px;
    margin-bottom: 14px;
    align-self: flex-start;
`;

export const ItemContainer = styled.div`
    display: flex;
    flex: 1;
    width: 80%; 
    max-height: 20px;
    align-items: center;
    justify-content: space-between;
    padding-top: 13px;
    padding-left: 19px;
    padding-bottom: 13px;
    padding-right: 12px;
    background-color: ${props => props.theme.brandColor2};
    margin: 0;
    border: 0;
    color: ${props => props.theme.brandColor3};
    border-bottom: 1px solid ${props => props.theme.brandColor5};
 `;

export const PortfolioName = styled.span`
    font-family: "SourceSansPro", Arial, sans-serif;
    font-size: 12px;
    font-weight: 300;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: left;
    color: ${props => props.theme.brandColor3};
    text-transform: uppercase;
 `;

export const ButtonsWrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-self: flex-end;
    margin-top: 20px;
`;